/* Candidate only -- one versioned manual vocabulary source for both UIs. */
(() => {
  'use strict';

  const sharedAliases = [
    { term: 'Hörmann', aliases: ['Hoermann', 'Hormann'] },
    { term: 'High-Line', aliases: ['High Line', 'Highline'] },
    { term: 'Select-Line', aliases: ['Select Line', 'Selectline'] },
    { term: 'Pro-Line', aliases: ['Pro Line', 'Proline'] },
    { term: 'A445', aliases: ['A 445', 'A-445'] },
    { term: 'WA300', aliases: ['WA 300', 'WA-300'] },
  ];

  const sharedCorrections = {
    hoermann: 'Hörmann',
    hormann: 'Hörmann',
    highline: 'High-Line',
    'high line': 'High-Line',
    selectline: 'Select-Line',
    'select line': 'Select-Line',
    proline: 'Pro-Line',
    'pro line': 'Pro-Line',
  };

  const make = (locale, extra = {}) => Object.freeze({
    locale,
    version: 'tm24-manual-vocabulary-2026-08-12.1',
    corrections: Object.freeze({ ...sharedCorrections, ...(extra.corrections || {}) }),
    aliases: Object.freeze([...sharedAliases, ...(extra.aliases || [])]),
    terms: Object.freeze(extra.terms || []),
    // Empty by design. Only an independently approved diagnosis map may add
    // entries; the theme adapter never derives diagnoses from general knowledge.
    diagnoses: Object.freeze(extra.diagnoses || []),
  });

  window.TM24SearchVocabularyManual = Object.freeze({
    de: make('de', {
      corrections: {
        laufrole: 'Laufrolle',
        'lauf rolle': 'Laufrolle',
        'lauf-rolle': 'Laufrolle',
      },
      aliases: [
        { term: 'Laufrolle', aliases: ['Lauf Rolle', 'lauf-rolle', 'laufrole'] },
      ],
      diagnoses: [
        {
          phrase: 'Lichtschranke defekt',
          terms: ['Lichtschranke'],
          disclaimer: true,
          source: 'TM24 Regression 2026-08-12',
        },
        {
          phrase: 'Tor fährt nicht runter',
          terms: ['Lichtschranke', 'Sicherheitskontaktleiste', 'Optosensor'],
          disclaimer: true,
          source: 'TM24 Legacy-Regel, kontrolliert 2026-08-12',
        },
      ],
    }),
    nl: make('nl'),
    fr: make('fr'),
  });
})();
